import TickerItem from "./TickerItem";

/**
 * Compone un objeto del API respetando: league → standing → results → upcoming → news.
 * Cada sección puede recibir su propio componente para personalizar sus reglas.
 */
export default function TickerItems({
  leagueItem,
  leagueContent,
  standings = [],
  standingContent,
  results = [],
  resultsContent,
  resultCards = [],
  upcoming = [],
  upcomingContent,
  newsContent,
  items
}) {
  if (items) {
    return <div className="ticker-league-group">
      {items.filter(Boolean).map((item, index) => <TickerItem key={`${item.text}-${index}`} item={item} />)}
    </div>;
  }

  return (
    <div className="ticker-league-group">
      {leagueContent || (leagueItem && <TickerItem item={leagueItem} />)}
      {standingContent || standings.filter(Boolean).map((item, index) => <TickerItem key={`standing-${index}`} item={item} />)}
      {resultsContent || (resultCards.length ? resultCards : results.filter(Boolean).map((item, index) => <TickerItem key={`result-${index}`} item={item} />))}
      {upcomingContent || upcoming.filter(Boolean).map((item, index) => <TickerItem key={`upcoming-${index}`} item={item} />)}
      {newsContent}
    </div>
  );
}